import { ref } from 'vue'
import Api from '@/api'
import store from '@/store'
import { SeriesResponse } from '@/types/cms';


const loggingEnabled = process.env.NODE_ENV !== 'production';
const log = (msg: string) => { if (loggingEnabled) console.log(`[CMSForYouManager] ${msg}`) }
type LoadingState = 'loading' | 'error' | 'success'

const series = ref<SeriesResponse[] | undefined>(undefined)
const state = ref<LoadingState>('loading')

async function loadForYouRail(userId: number) {
  try {
    log('Loading for you rail...')
    const response = await Api.CMS.forYouRail(userId)
    series.value = response
    log(`Got ${response.length} for you series`)
    state.value = 'success'
    store.commit('CACHE_CONTENT', { series: response })
  } catch (error) {
    log(`Failed to fetch rails: ${error}`)
    state.value = 'error'
  }
}


export const CMSForYouManager = {
  series,
  state,
  loadForYouRail
}